
export default {
    cargo: {},
    cargos: []
}